<template>
  <div>
    <div class="flex items-center mb-base" v-if="showOption.private">
      <VCheckbox
        id="sharing-private"
        data-test="radio-private"
        type="radio"
        :disabled="!value"
        @input="handleCheckboxUpdate"
        name="sharing_type"
        :checked="value === 'private'"
        radio-value="private"
        data-ec="sharing_type"
        data-et="private"
      />
      <label for="sharing-private" class="ml-base" :disabled="!value">
        {{ $t('envelope.privateToMe') }}
      </label>
    </div>
    <div class="flex items-center mb-base" v-if="showOption.everyone">
      <VCheckbox
        id="sharing-everyone"
        data-test="radio-everyone"
        type="radio"
        :disabled="!value"
        @input="handleCheckboxUpdate"
        name="sharing_type"
        :checked="value === 'everyone'"
        radio-value="everyone"
        data-ec="sharing_type"
        data-et="everyone"
      />
      <label for="sharing-everyone" class="ml-base" :disabled="!value">
        {{ $t('sharing.shareWithEveryone', { companyName: company.name }) }}
      </label>
    </div>
    <div class="flex items-center mb-base" v-if="showOption.individuals">
      <VCheckbox
        id="sharing-individuals"
        data-test="radio-individuals"
        type="radio"
        :disabled="!value || !allowSharingWithIndividuals"
        @input="handleCheckboxUpdate"
        name="sharing_type"
        :checked="value === 'individuals'"
        radio-value="individuals"
        data-ec="sharing_type"
        data-et="individuals"
      />
      <label for="sharing-individuals" class="ml-base" :disabled="!value || !allowSharingWithIndividuals">
        {{ $t('envelope.specificUsersAndTeams') }}
      </label>
      <i18n
        v-if="!allowSharingWithIndividuals && userHasRole('super-admin')"
        data-test="upsell-link"
        path="url"
        tag="p"
        class="ml-2"
      >
        <template v-slot:url>
          <RouterLink :to="{ name: 'Billing'}" data-ec="envelope-create" data-et="upgrade-your-plan">
            {{ $t('companyProfile.billing.upgradeForThisFeature') }}
          </RouterLink>
        </template>
      </i18n>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VCheckbox from '@/components/deprecated/atoms/Checkbox.vue';

export default {
  name: 'SharingTypeSelection',

  components: {
    VCheckbox,
  },

  props: {
    value: {
      type: String,
      required: false,
    },
    visibility: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters({
      company: 'company/company',
      userHasRole: 'roles/userHasRole',
      planHasFeature: 'plan/planHasFeature',
    }),
    showOption() {
      return Object.assign({
        private: true,
        everyone: true,
        individuals: true,
      }, this.visibility);
    },
    allowSharingWithIndividuals() {
      return this.planHasFeature('team');
    },
  },

  methods: {
    handleCheckboxUpdate(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped>
label {
  cursor: pointer;
}
label[disabled] {
  opacity: 0.5;
  cursor: default;
}
</style>
